

    <div class="row dv-dshrbrd">
      <div [ngClass]="{'col-md-12': orderlineChartData[0].data.length === 0,'col-md-6': orderlineChartData[0].data.length > 0}">
                      <div class="card">
                          <div class="card-header">
                              Total Revenue
                              <div *ngIf="userRole === 'SuperAdmin' ||userRole==='CustomerService'">
                                <form [formGroup]="revenueChartForm">
                                  <label class="label">
                                      <mat-form-field>
                                          <mat-select class="order-st-select" (selectionChange)="fn_GetSuperAdminRevnueChartData($event.value)"
                                              formControlName="StoreId">
                                              <mat-option value="0">All</mat-option>
                                              <mat-option *ngFor="let storeItem of storeList; let i=index" [value]="storeItem.StoreId">{{storeItem.StoreName}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </label>
                              </form>
                            </div>
                          </div>
                          <div class="card-body sl-graph">
                <div style="display: block;">
                <canvas baseChart *ngIf="displayRevenueLineChart"
                            [datasets]="revenuelineChartData"
                            [labels]="revenuelineChartLabels"
                            [options]="revenuelineChartOptions"
                            [colors]="revenuelineChartColors"
                            [legend]="revenuelineChartLegend"
                            (chartHover)="revenuechartHovered($event)"
                            (chartClick)="revenuechartClicked($event)"
                            [type]="revenuelineChartType"></canvas>
                </div>
                </div>
             </div>
      </div>

      <div *ngIf="orderlineChartData[0].data.length > 0" [ngClass]="{'col-md-6': orderlineChartData[0].data.length > 0}">
          <div class="card">
              <div class="card-header">
                  Order statistic
              </div>
              <div class="card-body sl-graph">
        <div style="display: block;">
        <canvas baseChart
                    [datasets]="orderlineChartData"
                    [labels]="orderlineChartLabels"
                    [options]="orderlineChartOptions"
                    [colors]="orderlineChartColors"
                    [legend]="orderlineChartLegend"
                    [type]="revenuelineChartType"
                    ></canvas>
        </div>
      </div>
    </div>
</div>
</div>
<!-- <div class="row"  *ngIf="orderlineChartData[0].data.length > 0">
  <div [ngClass]="{'col-md-6': orderlineChartData[0].data.length > 0}">
    <div style="display: block;">
    <canvas baseChart
                [datasets]="orderlineChartData"
                [labels]="orderlineChartLabels"
                [options]="orderlineChartOptions"
                [colors]="orderlineChartColors"
                [legend]="orderlineChartLegend"
                [chartType]="orderlineChartType"></canvas>
    </div>
  </div>
</div> -->
